/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AssignAuthSupportRequestBody } from '../../models/assign-auth-support-request-body';

export interface VehicleAddAuthSupport$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The object ID. Must be a valid ID.
 */
  vehicleUid: string;
      body: AssignAuthSupportRequestBody
}

export function vehicleAddAuthSupport(http: HttpClient, rootUrl: string, params: VehicleAddAuthSupport$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, vehicleAddAuthSupport.PATH, 'post');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('vehicleUid', params.vehicleUid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

vehicleAddAuthSupport.PATH = '/subscriptions/{uid}/vehicles/{vehicleUid}/auth-supports/assign';
